import React from 'react'
import { Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
const useStyles = makeStyles((theme) => ({
  input: {
    'max-width': `calc(100% - 48px)`,
  },
}))

export const RowInputTwoColumns = ({ icon, columnOne, columnTwo }) => {
  return (
    <RowInput icon={icon}>
      <div className="ltr:pr-0 rtl:pl-0 pb-20 sm:pb-0 sm:ltr:pr-3 rtl:pl-3 w-full sm:w-1/2">
        {columnOne}
      </div>
      <div className="ltr:pl-0 rtl:pr-0 sm:ltr:pl-3 rtl:pr-3 w-full sm:w-1/2">
        {columnTwo}
      </div>
    </RowInput>
  )
}

export const RowInput = ({ icon, className, ...rest }) => {
  const classes = useStyles()
  return (
    <div className={clsx('flex mt-24', className)}>
      <div className="min-w-48 pt-20">
        <Icon>{icon}</Icon>
      </div>
      <div
        className={clsx(classes.input, 'flex flex-auto flex-col sm:flex-row')}
        {...rest}
      ></div>
    </div>
  )
}
